import { returnErrors } from './errorAction';
import { postJobApiCall } from '../../utils/jobRequest';
import { VALIDATE_VIDEO_CODE_FAILURE, VALIDATE_VIDEO_CODE_REQUEST, VALIDATE_VIDEO_CODE_SUCCESS } from '../Types/types';

export const validateVerificationCode = (video_call_id, verification_code) => async (dispatch) => {
  dispatch({ type: VALIDATE_VIDEO_CODE_REQUEST });
  try {
    const res = await postJobApiCall("video-call/validate-code", { video_call_id, verification_code });
    dispatch({ type: VALIDATE_VIDEO_CODE_SUCCESS, payload: res.data.data });
    return { success: true };
  } catch (error) {
    dispatch({ type: VALIDATE_VIDEO_CODE_FAILURE });
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.detail ||
      (error?.response?.status === 403
        ? "Insufficient credits. Please contact your administrator."
        : "Invalid verification code or Insufficient credits. Please contact your administrator.");

    return { success: false, message };
  }
};
